import axios from 'axios';

const base = 'panel-tool';

function syncNubicom() {
    return axios.post(`${base}/sync-nubicom`);
}

function syncStrong() {
    return axios.post(`${base}/sync-strong`);
}

function syncSoftland() {
    return axios.post(`${base}/sync-softland`);
}

function syncLugares() {
    return axios.post(`${base}/sync-lugares`);
}

function getLastSyncs() {
    return axios.get(`${base}/last-syncs`);
}

function getPorcentajeDA() {
    return axios.get(`${base}/porcentaje-da`);
}

function setPorcentajeDA(porcentaje) {
    return axios.post(`${base}/porcentaje-da`, { porcentaje });
}

const PanelToolService = { syncNubicom, syncStrong, syncSoftland, syncLugares, getLastSyncs, getPorcentajeDA, setPorcentajeDA };
export default PanelToolService;
